import { render } from "./PcInput.vue?vue&type=template&id=1267f9ae"
import script from "./PcInput.vue?vue&type=script&lang=js"
export * from "./PcInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__